import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => {
  const itemId = createTemporaryEntityId();
  return {
    data: {
      type: 'paragraph--explore_brands',
      id: createTemporaryEntityId(),
      attributes: {
        langcode: getEntityTemplateLang(),
        status: true,
        default_langcode: true,
        field_search_text: null,
        field_title: { value: 'Explore further brands', format: 'rich_text' },
      },
      relationships: {
        field_tags: {
          data: [],
        },
        field_items: {
          data: [
            {
              type: 'paragraph--explore_brands_item',
              id: itemId,
            },
          ],
        },
      },
      links: {},
      log: [],
      permissions: {
        update: true,
        create: true,
        delete: true,
      },
    },
    included: [
      {
        type: 'paragraph--explore_brands_item',
        id: itemId,
        attributes: {
          langcode: getEntityTemplateLang(),
          status: true,
          default_langcode: true,
          field_hide_title: false,
          field_link_external: null,
          field_link_module: null,
          field_link_text: 'To guideline',
          field_search_text: null,
          field_title: { value: 'BRAND', format: 'rich_text' },
        },
        relationships: {
          field_image: {},
          field_tags: {
            data: [],
          },
        },
        links: {},
        log: [],
        permissions: {
          update: true,
          create: true,
          delete: true,
        },
      },
    ],
  };
};
